import styles from "../../analytics.module.css"


const AlertDetailModal = ({setSelectedAlert, setAlertDetail, alertDetail}) => {
	return (
		<div
			className={styles.modalOverlay}
			onClick={() => {
				setSelectedAlert(null)
				setAlertDetail(null)
			}}
		>
			<div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
				<div className={styles.modalHeader}>
					<h2>Alert Details</h2>
					<button
						className={styles.closeButton}
						onClick={() => {
							setSelectedAlert(null)
							setAlertDetail(null)
						}}
					>
						×
					</button>
				</div>


				<div className={styles.alertDetailGrid}>
					<div className={styles.detailRow}>
						<strong>Title:</strong>
						<span>{alertDetail.title}</span>
					</div>
					<div className={styles.detailRow}>
						<strong>Message:</strong>
						<span>{alertDetail.message}</span>
					</div>
					<div className={styles.detailRow}>
						<strong>Type:</strong>
						<span>{alertDetail.alertType}</span>
					</div>
					<div className={styles.detailRow}>
						<strong>Severity:</strong>
						<span className={styles[alertDetail.severity]}>{alertDetail.severity}</span>
					</div>
					<div className={styles.detailRow}>
						<strong>Status:</strong>
						<span>{alertDetail.status}</span>
					</div>
					<div className={styles.detailRow}>
						<strong>Priority:</strong>
						<span>{alertDetail.priority}</span>
					</div>
					<div className={styles.detailRow}>
						<strong>Created:</strong>
						<span>{new Date(alertDetail.createdAt).toLocaleString()}</span>
					</div>
					<div className={styles.detailRow}>
						<strong>Last Occurrence:</strong>
						<span>{new Date(alertDetail.lastOccurrence).toLocaleString()}</span>
					</div>
					{alertDetail.acknowledgedBy && (
						<div className={styles.detailRow}>
							<strong>Acknowledged:</strong>
							<span>{new Date(alertDetail.acknowledgedAt).toLocaleString()}</span>
						</div>
					)}
				</div>

				{alertDetail.relatedEntity && (
					<div className={styles.relatedEntity}>
						<h3>Related Entity</h3>
						<p>Type: {alertDetail.relatedEntity.type}</p>
						<p>Name: {alertDetail.relatedEntity.name}</p>
						<p>ID: {alertDetail.relatedEntity.id}</p>
					</div>
				)}

				{alertDetail.triggerData && (
					<div className={styles.triggerData}>
						<h3>Trigger Data</h3>
						<pre>{JSON.stringify(alertDetail.triggerData, null, 2)}</pre>
					</div>
				)}

				{alertDetail.autoActions && alertDetail.autoActions.length > 0 && (
					<div className={styles.autoActions}>
						<h3>Auto Actions</h3>
						<ul>
							{alertDetail.autoActions.map((action, index) => (
								<li key={index}>{action}</li>
							))}
						</ul>
					</div>
				)}
			</div>
		</div>
	)
}

export default AlertDetailModal